import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { GetPropertiesDTO } from '../dtos';
import { getProperties, selectProperties } from '../feature';

export const useGetProperties = (isSold = false) => {
  const dispatch = useAppDispatch();

  const properties = useAppState(selectProperties);

  useEffect(() => {
    const dto = new GetPropertiesDTO({});
    dispatch(getProperties({ ...dto, isSold }));
  }, [isSold]);

  return properties;
};
